import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { userService, UserRole } from '@/service/user-service'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        children: [

            {
                path: '/add',
                name: 'add',
                component: () => import(/* webpackChunkName: "add" */ '../views/AddProductView.vue')
            },
            {
                path: '/edit/:id',
                name: 'EditProduct',
                component: () => import(/* webpackChunkName: "edit" */ '../views/AddProductView.vue')
            },
            {
                path: '/login',
                name: 'login',
                component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
            },
            {
                path: '/all',
                name: 'all',
                component: () => import(/* webpackChunkName: "all" */ '../views/AllProductsView.vue')
            },
            {
                path: '/about',
                name: 'about',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
            },
            {
                path: '/sell',
                name: 'Sell',
                component: () => import(/* webpackChunkName: "sell" */ '../views/SellView.vue')
            },
            {
                path: '/clients',
                name: 'Clients',
                component: () => import(/* webpackChunkName: "clients" */ '../views/ClientsView.vue')
            },
            {
                path: '/client/:id/orders',
                name: 'ClientOrders',
                component: () => import(/* webpackChunkName: "client-orders" */ '../views/ClientOrdersView.vue')
            },
            {
                path: '/organizations',
                name: 'Organizations',
                component: () => import(/* webpackChunkName: "organizations" */ '../views/OrganizationsView.vue')
            },
            {
                path: '/orders',
                name: 'Orders',
                component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersView.vue')
            },
            {
                path: '/print',
                name: 'Print',
                component: () => import(/* webpackChunkName: "print" */ '../views/PrintView.vue')
            },
            {
                path: '/category/manage',
                name: 'CategoryManage',
                component: () => import(/* webpackChunkName: "category" */ '../views/ManageCategoriesView.vue')
            },
            {
                path: '/unit-types',
                name: 'UnitTypes',
                component: () => import(/* webpackChunkName: "unit-types" */ '../views/UnitTypesView.vue')
            },
            // Branch Management Routes
            {
                path: '/branches',
                name: 'BranchManagement',
                component: () => import(/* webpackChunkName: "branches" */ '../views/BranchManagementView.vue')
            },
            {
                path: '/branch-users',
                name: 'BranchUserManagement',
                component: () => import(/* webpackChunkName: "branch-users" */ '../views/BranchUserManagementView.vue'),
                meta: { requiresRole: 'MANAGER' }
            },
            // Admin Routes
            {
                path: '/admin',
                name: 'AdminDashboard',
                component: () => import(/* webpackChunkName: "admin-dashboard" */ '../views/AdminDashboardView.vue'),
                meta: { requiresRole: 'ADMIN' }
            },
            {
                path: '/admin/users',
                name: 'AdminUserManagement',
                component: () => import(/* webpackChunkName: "admin-users" */ '../views/AdminUserManagementView.vue'),
                meta: { requiresRole: 'ADMIN' }
            },
            {
                path: '/admin/organizations',
                name: 'AdminOrganizationManagement',
                component: () => import(/* webpackChunkName: "admin-organizations" */ '../views/AdminOrganizationManagementView.vue'),
                meta: { requiresRole: 'ADMIN' }
            },
        ]
    },
    {
        path: '/template/:name/:title/:code',
        name: 'template',
        component: () => import(/* webpackChunkName: "template" */ '../components/print/PrintTemplate.vue')
    },
    // Silent printing route (outside main layout)
    {
        path: '/print-receipt/:orderId?',
        name: 'PrintReceipt',
        component: () => import(/* webpackChunkName: "print-receipt" */ '../views/PrintReceiptView.vue'),
        meta: { layout: 'print' } // Special layout for printing
    }
]
// check token before each route
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// Route guards
router.beforeEach((to, from, next) => {
    // Check if route requires authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!userService.isAuthenticated()) {
            next({ name: 'login' });
            return;
        }
    }

    // Check if route requires specific role
    if (to.matched.some(record => record.meta.requiresRole)) {
        const requiredRole = to.meta.requiresRole as UserRole;
        
        if (!userService.isAuthenticated()) {
            next({ name: 'login' });
            return;
        }

        if (!userService.hasRoleOrHigher(requiredRole)) {
            // Redirect to home or show unauthorized message
            next({ name: 'home' });
            return;
        }
    }

    next();
});

export default router
